<script>
import Status from '../../../../components/common/Status'
import Audio from '../../../../components/common/Audio.vue'
import { invoiceMixins, teamTaskMixins, userTeamMixins } from '../../../../utils/mixins'
export default {
  mixins: [userTeamMixins, teamTaskMixins, invoiceMixins],
  components: {
    Status,
    Audio,
  },
  props: {
    striped: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
    },
    selectRoute: {
      type: String,
      default: '',
    },
    imgStyle: {
      type: String,
    },
    imgClass: {
      type: String,
    },
    clickToChangeRoute: {
      default: true,
      type: Boolean,
    },
    // isCrm: {
    //   default: false,
    //   type: Boolean,
    // },
    fields: {
      default: [],
    },
    rows: {
      default: [],
    },
    // fixedHeight: {
    //   type: Boolean,
    //   default: false,
    // },
    // invoice: {
    //   type: Boolean,
    //   default: false,
    // },
    // paginationData: {
    //   type: Object,
    // },
    tableId: {
      default: '',
    },
    noNeedToChangeRoute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      selectMode: 'single',
      selected: null,
      filter: null,
      filterOn: [],
      items: null,
    }
  },
  methods: {
    goDetail(row) {
      if (this.$route.name === 'dadbananUserDetail') return
      if (!this.noNeedToChangeRoute) {
        this.onRowSelected(row)
      }
      this.$emit('selectedRow', row)
    },
    addTab(payload) {
      return this.addTeamTaskTab({
        teamTaskTab: payload,
      })
    },
    setActiveTabName(payload) {
      return this.setActiveTab({
        activeTab: payload,
      })
    },
    onRowSelected(items) {
      if (this.clickToChangeRoute === true) {
        if (this.tableId === 'cryptowallet') {
          this.setSelectedRow({ items })
          this.$router.push({ path: `/list/specificUserWalletTransactions/fromUserManagement/${items.items[1].value}/${this.$route.params.id}` })
          this.selected = items
        } else {
          this.$router.push({ path: `${this.selectRoute}/${items.key}` })
          this.selected = items
        }
      } else {
        this.addTab(items.key)
        this.setActiveTabName(items.key)
        const path = this.$route.path
        this.$router.push({ path: `${path}?navLink=${items.key}` })
      }
    },
    GridView() {
      this.$router.push({ path: '/teamtask-board' })
    },
    timeSpanConverter(data) {
      let splitedData = data.split(':')
      let finalData = ''
      if (splitedData[0] != '00') {
        finalData = splitedData[0] + ' ساعت و ' + splitedData[1] + ' دقیقه و ' + splitedData[2] + ' ثانیه '
      } else if (splitedData[0] == '00') {
        finalData = splitedData[1] + ' دقیقه و ' + splitedData[2] + ' ثانیه '
      } else if (splitedData[0] == '00' && splitedData[1] == '00') {
        finalData = splitedData[2] + ' ثانیه '
      } else return
      return finalData
    },
  },
  computed: {
    routeName() {
      return this.$route.name
    },
  },
  watch: {
    currentPage(newPage, oldPage) {
      if (newPage === oldPage) return
      if (newPage > 1) {
        this.$emit('tableObj', { tableId: this.tableId, page: newPage })
      }
    },
  },
}
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table main-table">
      <thead class="mainThead">
        <tr>
          <th v-for="col in fields" :key="col.key" class="ellipsis">
            <span data-bs-toggle="tooltip" :title="col.label">{{ col.label }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="rows.length > 0">
        <tr v-for="row in rows" :key="row.id" @click="goDetail(row)">
          <td v-for="data in row.items" :key="data.columnId" :style="`width:${data.size}%`" class="ellipsis">
            <span v-if="data.type == 'DateTimeOffset' && data.value">{{ FormatedDate(data.value) }}</span>
            <span v-else-if="data.type == 'Date' && data.value">{{ convertDate(data.value) }}</span>
            <span v-else-if="data.type == 'DateTime' && data.value">{{ convertToDateAndTime(data.value) }}</span>
            <span v-else-if="data.type == 'Price'" data-bs-toggle="tooltip" :title="Commafy(data.value)" class="dLTR">
              <template v-if="data.value">
                {{ Commafy(data.value) }}
              </template>
              <hr class="customHR" v-else />
            </span>
            <span v-else-if="data.type == 'Status' && data.value"><Status :status="data" color="#ff0000" /></span>
            <span v-else-if="data.type == 'Voice' && data.value"><Audio :file="data.value" /></span>
            <span v-else-if="data.type == 'dropDown' && data.value"><Dropdown simpleDropdown :items="data" /></span>
            <span v-else-if="data.type == 'TimeSpan' && data.value">{{ timeSpanConverter(data.value) }}</span>
            <span v-else-if="data.type == 'Image' && data.value"
              ><img
                class="default-Img-class"
                :class="routeName == 'transactions-fromUserManagement' || routeName == 'transactions-fromListsWallet' ? 'transactionMode' : ''"
                :src="data.value"
                :alt="data.type"
                height="36"
                width="36"
            /></span>
            <span
              v-else-if="(data.type == 'Color' && data.value) || (data.type == 'Color' && data.color)"
              class="d-flex align-items-center justify-content-start colorMainDiv"
              data-bs-toggle="tooltip"
              :title="data.value"
            >
              <span class="colorDiv me-2" :style="`background-color:${data.color}`" v-if="data.color"></span>
              <span class="colorValue" v-if="data.value">{{ data.value }}</span>
            </span>
            <span v-else-if="data.type == 'Icon' && data.value"><i :class="`${data.value} fileStyle`" :style="`color:${data.color}`"></i></span>
            <span v-else-if="data.value" data-bs-toggle="tooltip" :title="data.value">{{ data.value }}</span>
            <hr class="customHR" v-else />
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="rows.length == 0">
      <slot name="emptyTable"></slot>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.colorMainDiv {
  top: 5px !important;
  right: 0 !important;
  left: 30px !important;
}
.customHR {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  max-width: 50px;
}
.dLTR {
  direction: ltr !important;
}
table {
  width: 100%;
}
.ellipsis {
  position: relative;
}
.ellipsis:before {
  content: '&nbsp;';
  visibility: hidden;
  // display: none;
}
.ellipsis > span {
  position: absolute;
  left: 0px;
  right: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filterTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
}
.globalFlex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.filterOptions {
  margin-right: 10px;
  width: 86px;
  height: 37px;
  padding: 8px 15px;
  background: #3ea3fc;
  border-radius: 30px;
}
.filterText {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: right;
  color: #ffffff;
}
.GridView {
  margin-right: 14px;
  cursor: pointer;
}
.imageTable {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: 50px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
}
.widthInherit {
  width: 36px;
  height: 36px;
}
::v-deep .table thead th {
  align-items: center;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
}
::v-deep .table td {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  text-align: right;

  color: #555555;
}
::v-deep .pointer {
  cursor: pointer !important;
}
.three-dot {
  width: 15px;
  height: 15px;
}
.main-table tbody tr:hover {
  cursor: pointer;
  background-color: #eee;
}
.topDivTable {
  height: 370px;
  overflow: auto;
  // overflow-x: hidden ;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.topDivTable::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.topDivTable {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.theadFixed {
  position: sticky;
  top: 0;
  z-index: 10;
}
.colorDiv {
  width: 12px;
  height: 12px;
  border-radius: 1px;
  position: relative !important;
}
.fileStyle {
  color: #0124cd;
  font-size: 20px;
}
.mainThead {
  background-color: #f8f9fa;
}
.transactionMode {
  width: 20px;
  height: 20px;
}
</style>
